interface NavIconProps {
  name: string;
  className?: string;
}

const PATHS: Record<string, string> = {
  overview:
    '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
  transactions:
    '<path d="M4 7h15m-4-4 4 4-4 4M20 17H5m4-4-4 4 4 4"/>',
  programmes:
    '<path d="m3 9 9-6 9 6M5 10v10h14V10M9 20v-7h6v7"/>',
  donors:
    '<path d="M20.8 5.6a5.5 5.5 0 0 0-7.8 0L12 6.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 22l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/>',
  scholarships:
    '<path d="m2 9 10-5 10 5-10 5-10-5Zm4 2v6q6 5 12 0v-6m4-2v9"/>',
  reports:
    '<path d="M6 3h8l4 4v14H6V3Zm8 0v5h4M9 12h6m-6 4h6"/>',
  settings:
    '<path d="m9 3-.6 3-2.6 1.5-3-.6L1.5 10l2.4 2-2.4 2 1.3 3.1 3-.6L8.4 18l.6 3h6l.6-3 2.6-1.5 3 .6 1.3-3.1-2.4-2 2.4-2-1.3-3.1-3 .6L15.6 6 15 3Z"/><circle cx="12" cy="12" r="3"/>',
  funding:
    '<path d="M20.8 5.6a5.5 5.5 0 0 0-7.8 0L12 6.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 22l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/>',
};

function navKeyFromPath(path: string): string {
  if (path === "/" || path === "") {
    return "overview";
  }
  return path.replace(/^\//, "").split("/")[0] ?? "overview";
}

export function NavIcon({ name, className = "" }: NavIconProps) {
  const key = navKeyFromPath(name);
  const inner = PATHS[key] ?? PATHS.overview ?? "";

  return (
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      className={["h-5 w-5 shrink-0 stroke-current", className].join(" ")}
      fill="none"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      dangerouslySetInnerHTML={{ __html: inner }}
    />
  );
}
